import { Profile } from "@/types/profile"
import maleBanned from '@/assets/images/male-banned.svg';
import femaleBanned from '@/assets/images/female-banned.svg';

export const getBannedAvatar = (profile: Profile): string => {
    if (profile.gender === 'male')
        return maleBanned
    if (profile.gender === 'female')
        return femaleBanned
    return ''
}
